import { Typography } from 'antd';
import UtilString from '../../utils/UtilString';

const { Text } = Typography;

const MyText = ({
  size,
  bold,
  style,
  strong,
  children,
  className = UtilString.EMPTY_STRING,
  ...otherProps
}) => {
  return (
    <Text
      {...otherProps}
      style={{
        fontSize: size,
        fontWeight: bold ? 'bold' : 'normal',
        ...style,
      }}
      strong={strong || false}
      className={`my_text ${className}`}
    >
      {children}
    </Text>
  );
};

export default MyText;
